module.exports = __webpack_public_path__ + "static/media/img3.19ed86e0.png";